/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogoutResponse
 */
export interface LogoutResponse {
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof LogoutResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof LogoutResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the LogoutResponse interface.
 */
export function instanceOfLogoutResponse(value: object): value is LogoutResponse {
    return true;
}

export function LogoutResponseFromJSON(json: any): LogoutResponse {
    return LogoutResponseFromJSONTyped(json, false);
}

export function LogoutResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogoutResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function LogoutResponseToJSON(json: any): LogoutResponse {
    return LogoutResponseToJSONTyped(json, false);
}

export function LogoutResponseToJSONTyped(value?: LogoutResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'error': value['error'],
    };
}

